import { Fragment } from "react";

import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { cn } from "@/common/utils/css.utils";
import {
  buildBreadcrumbListSchema,
  serializeJsonLd,
} from "@/common/utils/json-ld.utils";
import ChevronRight from "@whoppah/icons/24/ChevronRight";

const BreadcrumbItem = ({ href, label }) => {
  return (
    <li className="inline-flex items-center font-body">
      {href ? (
        <Link
          href={href}
          prefetch={false}
          className="inline-flex whitespace-nowrap text-sm font-medium hover:underline md:whitespace-normal"
        >
          {label}
        </Link>
      ) : (
        <a
          disabled
          tabIndex="-1"
          className="inline-flex whitespace-nowrap text-sm font-medium hover:underline md:whitespace-normal"
        >
          {label}
        </a>
      )}
    </li>
  );
};

const Breadcrumb = ({
  items,
  horizontalScroll = false,
  visibleOnMobile = false,
}) => {
  const { t } = useTranslation("common");
  const { locale, defaultLocale } = useRouter();

  const allItems = [{ label: t("common_home"), href: "/" }, ...items];

  const richResults = buildBreadcrumbListSchema(
    allItems,
    locale,
    defaultLocale
  );

  return (
    <>
      <nav
        className={cn(
          "mb-2 py-1.5 text-gray-600 md:py-0 dark:text-gray-200",
          visibleOnMobile ? "flex" : "hidden md:flex",
          horizontalScroll && "no-scrollbar overflow-x-auto"
        )}
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center space-x-0.5 text-gray-500">
          {allItems.map((props, index) => (
            <Fragment key={props.label}>
              {index > 0 ? <ChevronRight className="text-grey-500" /> : null}
              <BreadcrumbItem {...props} />
            </Fragment>
          ))}
        </ol>
      </nav>
      {/* react-schemaorg's JsonLd HTML-escapes "&" to a literal "&amp;"
          inside the script, which Google reads as part of the name. */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(richResults) }}
      />
    </>
  );
};

export default Breadcrumb;
